module.exports = __webpack_public_path__ + "img/arrow_left_long.ec203ace.svg";